import React from 'react';
import { IconProps } from '@/components/Icons/types/IconInterface';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';

const StarEmptyIcon: React.FC<IconProps> = ({ size, variant, className }) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.38894 1.09648C9.58108 0.634506 10.2355 0.634506 10.4277 1.09648L12.5536 6.20794C12.6347 6.4027 12.8178 6.53577 13.0281 6.55262L18.5463 6.99502C19.0451 7.035 19.2473 7.65741 18.8673 7.98291L14.663 11.5844C14.5028 11.7216 14.4328 11.9369 14.4818 12.1421L15.7663 17.5269C15.8823 18.0136 15.3529 18.3983 14.9259 18.1375L10.2015 15.2519C10.0215 15.1419 9.79511 15.1419 9.6151 15.2519L4.89071 18.1375C4.46372 18.3983 3.93426 18.0136 4.05036 17.5269L5.33484 12.1421C5.38379 11.9369 5.31383 11.7216 5.15363 11.5844L0.949311 7.98292C0.569322 7.65741 0.771555 7.035 1.2703 6.99502L6.78854 6.55262C6.9988 6.53577 7.18196 6.4027 7.26296 6.20794L9.38894 1.09648Z"
      stroke="#4D5788"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StarEmptyIcon;
